import { render, staticRenderFns } from "./Blog.vue?vue&type=template&id=dcc4d8dc&scoped=true&"
import script from "./Blog.vue?vue&type=script&lang=ts&"
export * from "./Blog.vue?vue&type=script&lang=ts&"
import style0 from "./Blog.vue?vue&type=style&index=0&id=dcc4d8dc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcc4d8dc",
  null
  
)

export default component.exports